import { getStylesObjFromCss } from '../../../../utils/common/styling.js';

var styles = getStylesObjFromCss({
    styles: {
        root: {
            padding: "20px 24px",
            overflow: "auto",
        },
    },
    componentName: "ModalBody",
});

export { styles };
//# sourceMappingURL=ModalBody.styles.js.map
